import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox"];
  static values = {
    maxCount: {
      type: Number,
      default: 3,
    },
  };

  declare checkboxTargets: HTMLInputElement[];
  declare maxCountValue: number;

  connect() {
    this.updateInputStates();
  }

  updateInputStates() {
    if (this.hasLimitBeenReached()) {
      this.disableUnSelectedInputs();
    } else {
      this.enableAllInputs();
    }
  }

  private hasLimitBeenReached(): boolean {
    return (
      this.checkboxTargets.filter((input) => input.checked).length >=
      this.maxCountValue
    );
  }

  private disableUnSelectedInputs() {
    this.checkboxTargets.forEach((input) => {
      if (!input.checked) {
        input.disabled = true;
      }
    });
  }

  private enableAllInputs() {
    this.checkboxTargets.forEach((input) => {
      input.disabled = false;
    });
  }
}
